import { Suspense, type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import RelatedPhotosRenderer, {
    type RelatedPhotosRendererProps,
} from './RelatedPhotosRenderer.tsx';

import styles from './RelatedPhotosRendererSuspense.scss';

const RelatedPhotosRendererSuspense: FC<RelatedPhotosRendererProps> = props => {
    return (
        <Suspense
            fallback={
                <div className={styles.spinnerWrapper}>
                    <div className={styles.spinner}>
                        <FormattedMessage
                            id="interiorPhoto.relatedPhotos.fetchingPhotos"
                            defaultMessage="Fetching Related Photos..."
                        />
                        <Spinner containerClass={styles.spinnerContainer} />
                    </div>
                </div>
            }
        >
            <RelatedPhotosRenderer {...props} />
        </Suspense>
    );
};

export default RelatedPhotosRendererSuspense;
